// ComplaintPolicy.js
'use strict';
'use client';
import { connect } from 'react-redux';
import { goBack } from 'redux-first-history';

import ComplaintPolicy from '../component/ComplaintPolicy.jsx';

const mapDispatchToProps = dispatch => {
  return {
    goBack: () => dispatch(goBack()),
  };
};

export default connect(null, mapDispatchToProps)(ComplaintPolicy);
